export function hasStaticTagName(value) {
    return (typeof value === 'function' &&
        value.hasOwnProperty('tagName') &&
        typeof value.tagName === 'string' &&
        value.tagName.includes('-'));
}
